import React, { useEffect } from 'react';
import { useBodyScrollLock } from '../../hooks/useBodyScrollLock';
import './TaskModals.css';

const ImageModal = ({ selectedImage, onClose }) => {
  // Lock body scroll when open
  useBodyScrollLock(!!selectedImage);

  // Close on ESC
  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose && onClose();
    };
    if (selectedImage) {
      window.addEventListener('keydown', onKeyDown);
    }
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [selectedImage, onClose]);

  if (!selectedImage) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) onClose && onClose();
  };

  return (
    <div className="modal-overlay task-modal-overlay image-modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-container image-viewer task-modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header task-modal-header">
          <div className="task-modal-header-content">
            <div className="task-title-row">
              <span className="task-id-pill">Image Preview</span>
            </div>
          </div>
          <button className="modal-close" onClick={onClose} aria-label="Close">×</button>
        </div>
        <div className="modal-body image-viewer-body">
          <img src={selectedImage} alt="Task image" />
        </div>
      </div>
    </div>
  );
};

export default ImageModal; 